import { useEffect } from 'react'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false, speed: 400 })

/**
 * PageLoader — thin top progress bar.
 * Used as Suspense fallback for lazy-loaded pages.
 * Auto-starts on mount, auto-completes on unmount.
 */
export const PageLoader = () => {
  useEffect(() => {
    NProgress.start()
    return () => {
      NProgress.done()
    }
  }, [])
  return null
}
